import { render, staticRenderFns } from "./MyOrganizationDashboard.vue?vue&type=template&id=3e6c5c2a"
import script from "./MyOrganizationDashboard.vue?vue&type=script&lang=js"
export * from "./MyOrganizationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports